// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__1HrZz","rootDefault":"Tag_rootDefault__1EvuG","rootPrimary":"Tag_rootPrimary__bpj8x"};